import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IStyleContext, StyleContext } from '../../styleState/styleContext';
import { Checkbox } from 'antd';

const UseCustomerSettingsCheckBox: React.FC = () => {
	const { toggleUseCustomerSettings, useCustomerSettings } = useContext<IStyleContext>(StyleContext);

	return (
		<Checkbox checked={useCustomerSettings} onChange={toggleUseCustomerSettings}>
			<Text translationNameSpace="mediaSettings" translationKey="useCustomerSettingsLabel" asFragment={true} />
		</Checkbox>
	);
};

export default React.memo(UseCustomerSettingsCheckBox);
